module.exports = __webpack_public_path__ + "assets/img/tableRegistered.4b6ddc01.png";